// Estilos da tela de Leads (/leads). Sem mockup próprio: segue Créditos SMS
// (cabeçalho com saldo) e Contatos (tabela com scroll horizontal).
import { makeStyles, alpha } from "@material-ui/core/styles";
import { AEROS, stateText } from "../../styles/aerosTokens";

export const SEARCHES_GRID = "minmax(0,1.6fr) minmax(0,1.1fr) 90px 100px 130px 140px 44px";

const useLeadsPageStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  const border = isLight ? theme.palette.divider : "rgba(255,255,255,0.07)";
  return {
    headerSubtitle: { fontSize: 12, color: theme.palette.text.secondary, marginTop: 2 },
    topGrid: {
      display: "grid",
      gridTemplateColumns: "minmax(0,1.2fr) minmax(0,1fr) minmax(0,1fr)",
      gap: 14,
      [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
    },
    saldoCard: {
      background: `linear-gradient(135deg, ${alpha(AEROS.defaultPrimary, 0.16)}, ${alpha(AEROS.cyan, 0.12)})`,
      border: `1px solid ${alpha(AEROS.defaultPrimary, 0.35)}`,
      borderRadius: 14, padding: "18px 20px", display: "flex", flexDirection: "column", gap: 4, minWidth: 0,
    },
    saldoLabel: { fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: stateText(theme, "#C08BFF", "purple") },
    saldoRow: { display: "flex", alignItems: "baseline", gap: 8 },
    saldoValue: { fontFamily: AEROS.fontDisplay, fontSize: 34, fontWeight: 700, letterSpacing: "-0.03em", fontVariantNumeric: "tabular-nums", color: theme.palette.text.primary, lineHeight: 1.1 },
    saldoUnit: { fontSize: 13, color: theme.palette.text.secondary, fontWeight: 600 },
    saldoHint: { fontSize: 11.5, color: theme.palette.text.primary },
    kpiCard: { backgroundColor: theme.palette.aeros.surface, border: `1px solid ${border}`, borderRadius: 14, padding: "16px 18px", minWidth: 0 },
    kpiLabel: { fontSize: 11, fontWeight: 600, color: theme.palette.text.secondary, textTransform: "uppercase", letterSpacing: "0.06em" },
    kpiValue: { fontFamily: AEROS.fontDisplay, fontSize: 24, fontWeight: 700, marginTop: 4, fontVariantNumeric: "tabular-nums", color: theme.palette.text.primary },

    card: { backgroundColor: theme.palette.aeros.surface, border: `1px solid ${border}`, borderRadius: 14, minWidth: 0, marginTop: 16 },
    cardHead: { display: "flex", alignItems: "center", padding: "14px 18px 12px", gap: 10, borderBottom: `1px solid ${border}`, flexWrap: "wrap" },
    cardTitle: { fontSize: 13, fontWeight: 700, color: theme.palette.text.primary },
    cardActions: { marginLeft: "auto", display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" },

    // Cabeçalho E linhas dentro do mesmo wrapper com scroll horizontal.
    tableScroll: { overflowX: "auto", WebkitOverflowScrolling: "touch" },
    rowHead: {
      minWidth: 760, display: "grid", gridTemplateColumns: SEARCHES_GRID, gap: 10, padding: "9px 18px",
      fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase",
      color: theme.palette.aeros.textTertiary, borderBottom: `1px solid ${border}`,
    },
    row: {
      minWidth: 760, display: "grid", gridTemplateColumns: SEARCHES_GRID, gap: 10, padding: "11px 18px",
      borderBottom: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.05)"}`,
      alignItems: "center", fontSize: 13, cursor: "pointer",
      "&:hover": { backgroundColor: alpha(AEROS.defaultPrimary, 0.04) },
    },
    rowSelected: { backgroundColor: alpha(AEROS.defaultPrimary, 0.08) },
    ellipsis: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: theme.palette.text.primary, fontWeight: 600 },
    muted: { color: theme.palette.text.secondary, fontVariantNumeric: "tabular-nums" },
    num: { textAlign: "right", fontVariantNumeric: "tabular-nums", color: theme.palette.text.primary },
    pill: { display: "inline-flex", alignItems: "center", gap: 6, fontSize: 11, fontWeight: 600, borderRadius: 99, padding: "3px 10px", whiteSpace: "nowrap" },
    pillDot: { width: 6, height: 6, borderRadius: "50%", flex: "none" },
    progress: { fontSize: 11, color: theme.palette.text.secondary, marginTop: 2 },
    vazio: { padding: "24px 18px", textAlign: "center", fontSize: 12.5, color: theme.palette.aeros.textTertiary },
    aviso: { display: "flex", alignItems: "center", gap: 8, padding: "10px 18px", fontSize: 12, color: stateText(theme, AEROS.warning, "warning"), "& .MuiSvgIcon-root": { fontSize: 16 } },

    // tabela de leads: colunas dinâmicas → grid montado inline com minWidth
    leadHead: { display: "grid", gap: 10, padding: "9px 18px", fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: theme.palette.aeros.textTertiary, borderBottom: `1px solid ${border}` },
    leadRow: { display: "grid", gap: 10, padding: "10px 18px", borderBottom: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.05)"}`, alignItems: "center", fontSize: 13 },
    leadCell: { minWidth: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: theme.palette.text.primary },
    link: { color: stateText(theme, AEROS.cyan, "info"), textDecoration: "none", "&:hover": { textDecoration: "underline" } },
    wppYes: { color: stateText(theme, AEROS.success, "success") },
    wppNo: { color: theme.palette.aeros.textTertiary },
    wppUnknown: { color: stateText(theme, AEROS.warning, "warning") },
    searchInput: { minWidth: 220, [theme.breakpoints.down("xs")]: { minWidth: 0, width: "100%" } },
    colMenuItem: { fontSize: 13 },
  };
});

export default useLeadsPageStyles;
